import { render, staticRenderFns } from "./PopUpTextGroup.vue?vue&type=template&id=b17c0218"
import script from "./PopUpTextGroup.vue?vue&type=script&lang=js"
export * from "./PopUpTextGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports